import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const reducedMotionQuery = window.matchMedia(
  "(prefers-reduced-motion: reduce)",
);

export const initStaffSliders = () => {
  for (const section of document.querySelectorAll(".js-staff-slider")) {
    const slider = section.querySelector(".js-staff-slider-container");
    const staffCount = Number(section.dataset.staffCount || 0);

    if (!slider || staffCount < 2) continue;

    const isTopSlider = section.classList.contains("p-topStaff");
    const useAutoplay = section.classList.contains("is-autoplay");

    new Swiper(slider, {
      modules: [Autoplay],
      slidesPerView: 1.4,
      centeredSlides: true,
      spaceBetween: isTopSlider ? 12 : 16,
      loop: true,
      speed: reducedMotionQuery.matches ? 0 : isTopSlider ? 2000 : 700,
      autoplay:
        useAutoplay && !reducedMotionQuery.matches
          ? {
              delay: 3200,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }
          : false,
      breakpoints: {
        600: {
          slidesPerView: Math.min(2, staffCount),
          centeredSlides: false,
          spaceBetween: 16,
        },
        960: {
          slidesPerView: Math.min(3, staffCount),
          centeredSlides: false,
          spaceBetween: isTopSlider ? 16 : 24,
        },
        1320: {
          slidesPerView: isTopSlider
            ? Math.min(4, staffCount)
            : Math.min(3, staffCount),
          centeredSlides: false,
          spaceBetween: isTopSlider ? 16 : 24,
        },
      },
    });
  }
};
